import React, { useState, Fragment, useCallback } from "react";
import "./DownloadFilesComponent.scss";
import { ImageIcon } from "../../../assets/icons";
import PdfImg from "../../../assets/images/pdf_icon.svg";
import SpinnerLoading from "../../SpinnerLoading/SpinnerLoading";
import { useBrowseFile } from "../../../hooks/useBrowseFile";
import { getFileExtension } from "../../../helpers/utils/utils";

const DownloadFilesComponent = ({
  fileData = []
}) => {
  const { handleBrowseFile, isFileDownloading } = useBrowseFile();

  return (
    <Fragment>
      <div className="file-download-container">
        <div>
          <div className="preveiw-container">
            {fileData?.length
              ? fileData.map((file) => (
                  <div key={file?.id} className="biblografia-pdf-container">
                    <button
                      onClick={() =>
                        handleBrowseFile(file?.id, getFileExtension(file?.name))
                      }
                    >
                      {getFileExtension(file?.name) === "pdf" ? (
                        <img src={PdfImg} alt="pdf" />
                      ) : (
                        <ImageIcon fillColor="var(--archeo-color)" width={"60px"} height={"60px"} />
                      )}
                      <p>{file?.name}</p>
                    </button>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DownloadFilesComponent;
